const LOAD_CONTACTS = (state, payload) => {
    state.contacts = payload;
};

export default {
    LOAD_CONTACTS,
};
